import {
    REQUEST_INVENTORY_RELOCATIONS,
    FETCH_INVENTORY_RELOCATIONS_SUCCESS,
    FETCH_INVENTORY_RELOCATIONS_FAILURE,
    SELECT_INVENTORY_RELOCATION,
    RESET_CURRENT_INVENTORY_RELOCATION,
    REQUEST_INVENTORY_RELOCATION_DETAIL,
    FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS,
    FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE,
    REQUEST_CREATING_INVENTORY_RELOCATION,
    CREATE_INVENTORY_RELOCATION_SUCCESS,
    CREATE_INVENTORY_RELOCATION_FAILURE,
    REQUEST_EDITING_INVENTORY_RELOCATION,
    EDIT_INVENTORY_RELOCATION_SUCCESS,
    EDIT_INVENTORY_RELOCATION_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentInventoryRelocation: null,
    currentInventoryRelocationDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    inventoryRelocationIsCreating: false,
    inventoryRelocationCreateError: null,
    inventoryRelocationCreated: false,
    inventoryRelocationIsEditing: false,
    inventoryRelocationEditError: null,
    inventoryRelocationEdited: false
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Relocation action handlers
        case REQUEST_INVENTORY_RELOCATIONS:
            return { ...state, error: null, isLoading: true };
        case FETCH_INVENTORY_RELOCATIONS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_INVENTORY_RELOCATIONS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_INVENTORY_RELOCATION:
            return { ...state, currentInventoryRelocation: action.payload };
        case RESET_CURRENT_INVENTORY_RELOCATION:
            return { ...state, currentInventoryRelocation: null, currentInventoryRelocationDetail: null };
        case REQUEST_INVENTORY_RELOCATION_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentInventoryRelocationDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_INVENTORY_RELOCATION:
            return { ...state, inventoryRelocationIsCreating: true, inventoryRelocationCreateError: null, inventoryRelocationCreated: false };
        case CREATE_INVENTORY_RELOCATION_SUCCESS:
            return { ...state, inventoryRelocationIsCreating: false, inventoryRelocationCreateError: null, inventoryRelocationCreated: true };
        case CREATE_INVENTORY_RELOCATION_FAILURE:
            const inventoryRelocationCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryRelocationIsCreating: false, inventoryRelocationCreateError: inventoryRelocationCreateError, inventoryRelocationCreated: false };
        case REQUEST_EDITING_INVENTORY_RELOCATION:
            return { ...state, inventoryRelocationIsEditing: true, inventoryRelocationEditError: null, inventoryRelocationEdited: false };
        case EDIT_INVENTORY_RELOCATION_SUCCESS:
            return { ...state, inventoryRelocationIsEditing: false, inventoryRelocationEditError: null, inventoryRelocationEdited: true };
        case EDIT_INVENTORY_RELOCATION_FAILURE:
            const inventoryRelocationEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryRelocationIsEditing: false, inventoryRelocationEditError: inventoryRelocationEditError, inventoryRelocationEdited: false };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/inventoryRelocations_reducer.js